import { Button, Stack, Typography } from "@mui/material";
import button from '../assets/svgGame/button.svg';
import buttonWide from '../assets/svgGame/button_wide.svg';
import qrIcon from '../assets/svgGame/qr_Icon.svg';

export default function GameButton({ onClick, title, hideIcon, wide }) {

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            height="100%"
            spacing={0.5}
        >
            <Button
                variant="text"
                disableRipple
                sx={{
                    width: '100%',
                    backgroundImage: `url(${wide ? buttonWide : button})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
                onClick={onClick}
            >
                <Typography
                    color="#4A2615"
                    fontWeight='bold'
                    sx={{
                        fontSize: {
                            xs: '1.3rem',
                            sm: '1.5rem',
                            md: '1.7rem'
                        }
                    }}
                >
                    {title}
                </Typography>
            </Button>

            {!hideIcon
                ? <img
                    src={qrIcon}
                    alt="QR Icon"
                    style={{ width: '40px', height: '40px' }}
                />
                : null
            }
        </Stack>
    );
}
